export const ENTITY = 'ORGANIZATION';
